export default __webpack_public_path__ + "static/media/tool-icon-ladder.ac67511e.svg";